import React from 'react'
import classnames from '@helpers/misc/classnames'

export type TextType = 'title' | 'subtitle' | 'body' | 'caption' | 'small'

export interface Props {
  children: React.ReactNode
  className?: string
  type?: TextType
  id?: string
}

export default function Text({type = 'body', className, children, id}: Props) {
  return (
    <div
      id={id}
      className={classnames(
        {
          'text-lg font-bold': type === 'title',
          'text-base font-bold': type === 'subtitle',
          'text-base': type === 'body',
          'text-sm': type === 'small',
          'text-xs': type === 'caption',
          'text-gray-900 dark:text-white': type !== 'caption',
          'text-gray-500 dark:text-gray-300': type === 'caption'
        },
        className
      )}>
      {children}
    </div>
  )
}
